import { EmailConfirmContent, EmailConfirmLayout } from '@features/EmailConfirm';

export default function ConfirmEmailPage() {
  return (
    <EmailConfirmLayout>
      <EmailConfirmContent />
    </EmailConfirmLayout>
  );
}
